<template>
  <div class="aftersale-detail-table">
    <el-table :data="data" border style="width: 100%" max-height="140">
      <el-table-column prop="ruigu_code" label="锐锢编码" width="130px">
      </el-table-column>
      <el-table-column prop="self_code" label="三方商品编码">
      </el-table-column>
      <el-table-column prop="name" label="商品名" width="400">
      </el-table-column>
      <el-table-column prop="spec" label="规格">
      </el-table-column>
      <el-table-column prop="unit" label="单位">
      </el-table-column>
      <el-table-column prop="applied_num" label="申请数量">

      </el-table-column>
      <el-table-column prop="applied_price" label="申请金额">
        <template slot-scope="scope">
          <div v-if="type === '3'">-</div>
          <div v-else>{{scope.row.applied_price}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="received_num" label="收货数量">
      </el-table-column>
      <el-table-column prop="accepted_num" label="确认数量">
      </el-table-column>
      <el-table-column prop="accepted_price" label="确认金额">
        <template slot-scope="scope">
          <div v-if="type === '3'">-</div>
          <div v-else>{{scope.row.accepted_price}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="returned_num" label="出库数量">
      </el-table-column>
      <el-table-column prop="price" label="单价">
      </el-table-column>
    </el-table>
    <div class="table-title">
      <h6>用户说明:</h6>
    </div>
    <el-table :data="data" border style="width: 100%">
      <el-table-column prop="ruigu_code" label="锐锢编码" width="130px">
      </el-table-column>
      <el-table-column prop="description" label="用户说明">
        <template slot-scope="scope">
          <span style="display:inline-block;width:100%;text-align:left;padding:0 5px;">{{scope.row.description}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="images" label="图片" width="150">
        <template slot-scope="scope">
          <div class="img-list" @click="checkImgs(scope.row.images)">
            <img :src="firstImg(scope.row.images)" alt="" width="100px;" >
            <!-- <img :src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1564650539848&di=9193b115faa35cd26fbd3c8bc16783a3&imgtype=0&src=http%3A%2F%2Fpic33.nipic.com%2F20131007%2F13639685_123501617185_2.jpg" alt="" width="250px;" height="250px;"> -->
            <!-- <span>{{scope.row.images}}</span> -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <imgFloat :imgsrc="imgs" :show.sync="showImgDialog" v-if="showImgDialog"></imgFloat>
    <!-- <el-dialog
      title="图片"
      :visible.sync="showImgDialog"
      append-to-body
      width="50%"
      >
      <el-carousel indicator-position="outside" :autoplay="false">
        <el-carousel-item v-for="item in imgs" :key="item">
          <img :src="item" alt="img" width="100%">
        </el-carousel-item>
      </el-carousel>
    </el-dialog> -->
  </div>
</template>
<script>
import imgFloat from '@/components/common/imgFloat'
export default {
  components: {imgFloat},
  props: ['data', 'type'],
  data () {
    return {
      imgs: [],
      showImgDialog: false

    }
  },
  methods: {
    checkImgs (imgs) {
      this.showImgDialog = true
      if (imgs) {
        let imgList = JSON.parse(imgs)
        this.imgs = imgList
        this.showImgDialog = true
      } else {
        this.imgs = []
        // this.showImgDialog = true
      }
    },
    firstImg (imgs) {
      if (imgs) {
        let imgList = JSON.parse(imgs)
        if (imgList.length > 0) {
          return imgList[0]
        }
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.table-title{
  margin:8px 0 5px 0;
  h6{
    font-size: 12px;
    color: #010101;
    margin: 0;
  }
}
.img-list{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/bigAftersale/aftersale-detail-table.vue